module.exports = __webpack_public_path__ + "static/media/data_esg.8e02ee96.svg";